import { createFileRoute, redirect } from '@tanstack/react-router';
import { PaymentSetupPage } from '../components/profile/settings/PaymentSetupPage';

export const Route = createFileRoute('/profile/settings/payments')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: PaymentSetupPage,
});
